<template>
    <div class="row">
        <div class="col-lg-12">
            <h1 class="page-header">Responsáveis pelos Compromissos</h1>

            <!-- Lista de compromissos -->
            <div class="col-xs-12">
                <list
                    ref="vuetable" 
                    :show-empty="true" 
                    api-url="planogoverno/compromisso"
                    report-title="Comptomissos do Plano de Governo" 
                    :fields="fields" 
                    :initial-page="pagina" 
                    :pageCollection="'compromissoDetails'"
                    :appendParams="filtros"
                >
                <template slot="filters">
                        <div class="collapse" id="filtros">

                            <div class="col-sm-6">
                                <label class="custom-font">Período</label>
                                <select class="form-control select-selected" v-model="periodo">
                                    <option value="">Todos</option>
                                    <option v-for="(value, index) in listas.periodos" :value="value" :key="index">
                                        {{ value }}
                                    </option>
                                </select>
                            </div>
                            
                            <div class="col-sm-6">
                                <label class="custom-font">Unidade Executora</label>
                                <div class="input-group">
                                    <span class="input-group-addon">
                                        <font-awesome-icon :icon="'sitemap'" />
                                    </span>
                                    <select class="form-control select-selected" v-model="unidade_executora">
                                        <option value="">Todas</option>
                                        <optgroup label="Secretarias">
                                            <option v-for="s in listas.secretarias" :key="s.sigla" :value="s.sigla" :title="s.nome">
                                                {{ s.sigla }}
                                            </option>
                                        </optgroup>
                                        <optgroup label="Autarquias">
                                            <option v-for="a in listas.autarquias" :key="a.sigla" :value="a.sigla" :title="a.nome">
                                                {{ a.sigla }}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <label class="custom-font">Compromisso (descritivo)</label>
                                <input type="text" class="form-control" placeholder="Pesquisar por descritivo..." v-model="descritivo">
                            </div>

                            <div class="col-sm-6">
                                <label class="custom-font">Responsável (SSHD)</label>
                                <input type="text" class="form-control" placeholder="Pesquisar por SSHD do responsável..." v-model="responsavel">
                            </div>

                            <!-- Filtro buttons -->
                            <div class="col-sm-4" style="padding-top: 15px;">
                                <button 
                                    @click="consultar()" 
                                    class="btn btn-default margem-topo"
                                    name="btnFiltrar"
                                >
                                    <font-awesome-icon :icon="'filter'" />
                                    Filtrar
                                </button>
                                <button 
                                    @click="limpar()" 
                                    class="btn btn-default margem-topo" 
                                    name="btnLimpar"
                                >
                                    <font-awesome-icon :icon="'eraser'" />
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>
                    </template>

                    <template slot="actions">
                        <button 
                            class="btn btn-default" 
                            data-toggle="collapse" 
                            data-target="#filtros"
                        >
                            <font-awesome-icon :icon="'filter'" /> Filtros
                        </button>
                    </template>

                    <template slot="rowrender" slot-scope="props">
                        <div>
                            <button 
                                title="Editar o Compromisso" 
                                type="button" 
                                class="btn btn-primary"
                                @click="editar(props.rowData)"
                            >
                                <font-awesome-icon :icon="'edit'" class="icon" />
                            </button>
                        </div>
                    </template>
                </list>
            </div>

            <SidePlanoGoverno
                ref="side"
                :navs="sideConfig"
                @fechaModal="handleFecharModal"
                @salvar-edicao="salvarEdicao"
            />
        </div>
    </div>
</template>

<script>
import SelectFuncionario from '@/components/SelectFuncionario'
import list from '@/components/common/DataTable'
import { request } from '@/request'
import SidePlanoGoverno from '../../../../components/planogoverno/SidePlanoGoverno.vue'

export default {
    components: { list, SelectFuncionario, SidePlanoGoverno },
    data() {
        return {
            fields: [
                {
                    name: 'periodo',
                    title: 'Período',
                    filterable: true,
                    titleClass: 'text-center text-nowrap',
                    dataClass: 'text-center text-nowrap'
                },
                {
                    name: 'unidade_executora',
                    title: 'Unidade',
                    filterable: true,
                    titleClass: 'text-center text-nowrap',
                    dataClass: 'text-center text-nowrap'
                },
                {
                    name: 'descritivo',
                    title: 'Compromisso',
                    filterable: true
                },
                {
                    name: 'responsavel_sshd',
                    title: 'Responsável',
                    filterable: true,
                    titleClass: 'text-center text-nowrap',
                    dataClass: 'text-center text-nowrap'
                },
                {
                    name: '__slot:actions',
                    title: 'Ações',
                    titleClass: 'text-center col-md-3',
                    dataClass: 'text-center'
                }
            ],
            sideConfig: [
                {
                    titulo: 'Editar',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'editar',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
            ],
            listas: {
                secretarias: [],
                autarquias: [],
                periodos: ['2021-2024', '2025-2028']
            },
            modal: {
                visivel: false,
                compromisso: null,
                novoResponsavel: ''
            },
        }
    },
    computed: {
        filtros() {
            return {
                periodo: this.periodo,
                unidade_executora: this.unidade_executora,
                descritivo: this.descritivo,
                responsavel: this.responsavel
            }
        },
        pagina: {
            get() {
                const { compromissoDetails } = this.$store.state.vuetableState;
                const { pagina } = compromissoDetails;
                return pagina;
            },
            set(value) {
                this.$store.commit('SET_FILTER_PAGE', {
                    collection: 'compromissoDetails',
                    value: value
                })
            }
        },
        periodo: {
            get() {
                return (
                    this.$store.state.vuetableState
                        .compromissoDetails
                        .filtros
                        .periodo
                        || ''
                )
            },
            set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'periodo',
                    collection: 'compromissoDetails',
                    value: value
                })
                this.resetPageStore()
            }
        },
        unidade_executora: {
            get() {
                return (
                    this.$store.state.vuetableState
                        .compromissoDetails
                        .filtros
                        .unidade_executora
                        || ''
                )
            },
            set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'unidade_executora',
                    collection: 'compromissoDetails',
                    value: value
                })
                this.resetPageStore()
            }
        },
        descritivo: {
            get() {
                return (
                    this.$store.state.vuetableState
                        .compromissoDetails
                        .filtros
                        .descritivo
                        || ''
                )
            },
            set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'descritivo',
                    collection: 'compromissoDetails',
                    value: value
                })
                this.resetPageStore()
            }
        },
        responsavel: {
            get() {
                return (
                    this.$store.state.vuetableState
                        .compromissoDetails
                        .filtros
                        .responsavel
                        || ''
                )
            },
            set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'responsavel',
                    collection: 'compromissoDetails',
                    value: value
                })
                this.resetPageStore()
            }
        }
    },
    created() {
        this.loadUnidades();
    },
    methods: {
        async loadUnidades() {
            try {
                const { data: { data: secretarias } } = await request.get('listar-secretarias');
                const { data: { data: autarquias } } = await request.get('listar-autarquias');
                this.listas.secretarias = secretarias;
                this.listas.autarquias = autarquias;
            } catch (err) {
                this.$toastr.e('Erro ao carregar unidades.');
            }
        },
        async editar(compromisso) {
            const painel = this.sideConfig.find(p => p.identidade === 'editar');

            painel.subtitulo = compromisso.descritivo;
            painel.data = compromisso;
            this.$refs.side.$emit('abreModal', painel.identidade)
        },
        async salvarEdicao(compromissoEditado) {
            try {
                const payload = {
                    descritivo: compromissoEditado.descritivo,
                    responsavel_sshd: compromissoEditado.responsavel_sshd,
                    user_sshd: this.$store.state.user.username
                }

                await request.put(`planogoverno/compromisso/${compromissoEditado.id}`, payload);

                this.$toastr.s('Compromisso atualizado com sucesso!');
                this.$refs.vuetable.refresh();
                this.$refs.side.$emit('fechaModal', 'editar');
            } catch (err) {
                console.error('Erro ao salvar edição:', err);
                this.$toastr.e('Erro ao salvar edição.');
            }
        },
        handleFecharModal(identidade) {
            this.$refs.side.$emit('fechaModal', identidade)
        },
        consultar() {
            this.$refs.vuetable.refresh();
        },
        limpar() {
            this.periodo = ''
            this.unidade_executora = ''
            this.descritivo = ''
            this.responsavel = ''

            this.$nextTick(() => {
                this.$refs.vuetable.refresh()
            })
        },
        resetPageStore() {
            this.$store.commit('SET_FILTER_PAGE', {
                collection: 'compromissoDetails',
                value: 1
            })
        }
    }
}
</script>

<style scoped>
.select-selected {
    color: #00615c;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 100%;
    max-width: 500px;
    margin: 0px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    font-family: 'Helvetica Neue', Arial, sans-serif;
    overflow: visible;
}

.modal-title {
    margin-top: 0;
    color: #00615c;
    font-size: 18px;
    font-weight: bold;
}

.modal-footer {
    margin-top: 15px;
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/admin/plano-governo/compromisso/EditarResponsaveis.vue